import React, { useState } from 'react';
import { Popover } from '@mui/material';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import useAppointmentSteps from '../../../appointment-steps/useAppointmentSteps';
import { stepProgressFor, readyLabelFor } from '../../../appointment-steps/appointmentSteps';
import StepsProgressRing from '../../../appointment-steps/components/StepsProgressRing';
import StepsChecklist from '../../../appointment-steps/components/StepsChecklist';
import styles from './NowStepsBadge.module.css';

/**
 * Etapas do paciente no "Agora na clínica": o selo mostra o andamento (anel
 * x/y ou "Pronto") e abre o checklist ali mesmo, para a recepção marcar sem
 * ir até a agenda. Sem etapas para o status, não renderiza.
 */
function NowStepsBadge({ appointment, onChecksChange }) {
  const steps = useAppointmentSteps();
  const [anchor, setAnchor] = useState(null);

  const progress = stepProgressFor(appointment, steps);
  if (!progress) return null;

  const useRequired = progress.totalRequired > 0;
  const done = useRequired ? progress.doneRequired : progress.done;
  const total = useRequired ? progress.totalRequired : progress.total;
  const readyLabel = readyLabelFor(progress.status);

  return (
    <>
      <button
        type="button"
        className={progress.ready ? styles.ready : styles.badge}
        onClick={(event) => setAnchor(event.currentTarget)}
        aria-haspopup="menu"
        aria-expanded={Boolean(anchor)}
        aria-label={progress.ready ? `${readyLabel}: ver etapas` : `Etapas feitas: ${done} de ${total}`}
      >
        {progress.ready ? (
          <>
            <CheckCircleRoundedIcon sx={{ fontSize: 14 }} />
            Pronto
          </>
        ) : (
          <>
            <StepsProgressRing done={done} total={total} size={13} />
            <span className={styles.count}>{done}/{total}</span>
          </>
        )}
      </button>

      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{ className: styles.menu }}
      >
        <div className={styles.title}>
          {progress.ready
            ? readyLabel
            : `Etapas · ${done} de ${total}${useRequired ? ' obrigatórias' : ''}`}
        </div>
        <StepsChecklist appointment={appointment} progress={progress} onChecksChange={onChecksChange} />
      </Popover>
    </>
  );
}

export default NowStepsBadge;
